import type { StreamProvider } from '@vgtv/api-client';
import { getConfigProvider } from '../../../utils/player/player';

import { usePlayer } from './PlayerProvider';
import { useCurrentAsset } from './CurrentAssetProvider';

export const useProvider = () => {
  const player = usePlayer();
  const { asset } = useCurrentAsset();

  const configProvider = getConfigProvider(player);

  return {
    assetProvider: (asset?.provider || configProvider) as
      StreamProvider | 'brandstudio',
    configProvider,
  };
};
